import useSWR from 'swr';
import api from '../../config/configApi';

const fetcher = async (url) => {
  try {
    const { data } = await api.get(url);

    if (data?.erro) {
      throw new Error(data?.mensagem || 'Erro na API');
    }

    return data?.unidades ?? [];
  } catch (err) {
    console.error('Erro ao buscar unidades:', err?.response?.status, err?.message);
    return [];
  }
};

export default function useUnidadesConfiguracoes() {
  const {
    data: unidades = [], error, isLoading, mutate,
  } = useSWR(
    '/unidade/unidades',
    fetcher,
  );

  const criarUnidade = async (payload) => {
    try {
      await api.post('/unidade/unidades', payload);
      await mutate();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        throw new Error('Sem permissão para criar unidade.');
      }
      throw err;
    }
  };

  const editarUnidade = async (id, payload) => {
    try {
      await api.put(`/unidade/unidades/${id}`, payload);
      await mutate();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        throw new Error('Sem permissão para editar unidade.');
      }
      throw err;
    }
  };

  return {
    unidades,
    isLoading,
    isError: !!error,
    criarUnidade,
    editarUnidade,
    refetch: mutate,
  };
}
